export const approved_withdrawals_field_defs = [
    {
        key: 'id',
        label: '#',
        sortable: true
    },
    {
        key: 'customer_name',
        sortable: true,
    },
    {
        key: 'phone_number',
        sortable: true,
    },
    {
        key: 'amount',
        sortable: true,
    },
    {
        key: 'approved_by',
        sortable: true
    },
    {
        key: 'status',
        sortable: true,
    },
    {
        key: 'date_created',
        sortable: true,
    },
    {
        key: 'date_approved',
        sortable: true,
    }
];
